<template>
    <div class="booking-widget">
        <div class="opentable-widget-container" v-html="content"></div>
    </div>
</template>

<script>
    'use strict';

    export default {
        name: "BookingWidget",
        props: {
            url: {
                type:     [String, URL],
                required: true
            }
        },
        data: () => ({
            content: ''
        }),
        created() {
            const opentableScriptTag = window.document.createElement('script');

            opentableScriptTag.setAttribute('type', 'application/javascript');
            opentableScriptTag.setAttribute('src', String(this.url));

            opentableScriptTag.addEventListener('load', _ => this.moveWidgetNode());
            opentableScriptTag.addEventListener('abort', _ => this.showWarning());
            opentableScriptTag.addEventListener('error', _ => this.showWarning());
            window.document.head.appendChild(opentableScriptTag);
        },
        methods: {
            moveWidgetNode() {
                const widgetNode = window.document.head.querySelector('div');
                this.content     = widgetNode.outerHTML;
            },

            showWarning() {
                this.content = '<span>Error</span>';
            }
        }
    }
</script>